import { Injectable } from '@angular/core';
import { ModuleUserAccessLevel } from '../../constants-types';
import {
    SharingUser,
    SharingUserServer
} from '../../core-data-model/SharingUser';

@Injectable({ providedIn: 'root' })
export class SharingUserTransformer {
    transformServerToClient(server: SharingUserServer[]): SharingUser[] {
        return server.map<SharingUser>((user) =>
            this.transformToSharingUser(user)
        );
    }

    transformToSharingUser(server: SharingUserServer): SharingUser {
        let isCompanyAdmin = false;
        if (
            server.accessLevel === ModuleUserAccessLevel.CompanyAdmin ||
            server.accessLevel === ModuleUserAccessLevel.Admin
        ) {
            // Mapping Company Admin as Admin and adding meta data to identify the same
            server.accessLevel = ModuleUserAccessLevel.Admin;
            isCompanyAdmin = true;
        }
        return {
            userId: server.userId,
            firstName: server.firstName,
            lastName: server.lastName,
            email: server.email,
            accessLevel: server.accessLevel,
            accessPolicy: server.accessPolicy,
            isCompanyAdmin: isCompanyAdmin,
            valid: true
        };
    }
}
